import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import 'Vendor/owlcarousel/owl.carousel.min';
import { isObject } from 'Lib/is-object/is-object';

let lastStateIsMobileScreen = isMobileScreen();
const cSliderOn = 'owl-carousel';
const $slider = $('.triple-news-slider__slider');
const sPic = '.triple-news-slider__pic';

function initLoaderImages(e) {
    onScreen(isObject(e) ? $(e.target).find(sPic) : $slider.find(sPic), loadSrcOrBg);
}

function isMobileScreen() {
    return (getW() < eksmoBP.smMin);
}

function setSliders() {
    if (isMobileScreen()) {
        $slider.trigger('destroy.owl.carousel').removeClass(cSliderOn);
        initLoaderImages();
    } else {
        $slider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    smartSpeed: speed,
                    dots: false,
                    nav: true,
                    navClass: ['triple-news-slider__prev arrow arrow_prev arrow_shadow', 'triple-news-slider__next arrow arrow_next arrow_shadow'],
                    navText: ['', ''],
                    items: 3,
                    slideBy: 3,
                    margin: 24,
                    touchDrag: false,
                    mouseDrag: false,
                    onInitialized: initLoaderImages,
                });
        });
    }
}

setSliders();

$('body').on('eksmoResizeWidth', () => {
    if (isMobileScreen() !== lastStateIsMobileScreen) {
        setSliders();
        lastStateIsMobileScreen = isMobileScreen();
    }
});